import { ComponentType } from "react"
import { usePathname, useRouter } from "next/navigation"

export function withRouter<T>(Comp: ComponentType<T>) {
    return function WithRouter(props: T) {
        const router = useRouter()
        const pathname = usePathname()
        return <Comp {...props} router={router} pathname={pathname} />
    }
}
